import { get } from './';
export const getSustainableLevels = () => get(`/sustainables`);
